export const SCOPES = {
  // PROFILE
  UPDATE_PROFILE: 'UpdateProfile',
};
